import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences'
import * as CryptoJS from 'crypto-js';

export const APP_TOKEN = 'app_token'
export const FCM_TOKEN = 'fcm_token'

@Injectable({
  providedIn: 'root'
})
export class PreferencesService { // service permettant de gérer le contenu du localStorage. Les clés et les valeurs stockées seront chiffrées avec une clé de chiffrement pour plus de sécurité.

  constructor() {}

  async set<T>(key: string, value: any) {
    await Preferences.set({key: key, value: JSON.stringify(value)})
  }

  async get<T>(key: string, defaultValue?: any): Promise<T | null> {
    const val = await Preferences.get({key: key});
    return val?.value
        ? JSON.parse(val.value) as T
        : defaultValue;
  }

  async remove(key: string) {
    await Preferences.remove({key: key});
  }
  
  async clearPreferences() {
    await Preferences.clear();
  }
}
